module.exports = __webpack_public_path__ + "img/icon-24-ic-times.39e3a360.svg";